import type { ShapedComponent, ShapeVertex } from '@repo/api-contracts';

/** 원을 3차 베지어 넷으로 근사할 때의 손잡이 길이 비율(반지름 대비). */
export const ELLIPSE_KAPPA = 0.5522847498;

/**
 * 점 편집을 시작할 모양의 바깥 고리 점(컴포넌트 mm). 다각형은 그대로, 사각형은 네 모서리(TL·TR·BR·BL),
 * 원형은 위·오른쪽·아래·왼쪽 부드러운 점 넷이다(손잡이 = 반지름 × κ, 모양은 눈으로 같다).
 */
export const editableVerticesOf = (component: ShapedComponent): ShapeVertex[] => {
  const { shape, widthMm: w, heightMm: h } = component;
  if (shape?.type === 'polygon') return [...shape.points];
  if (shape?.type === 'ellipse') {
    const rx = w / 2;
    const ry = h / 2;
    const kx = rx * ELLIPSE_KAPPA;
    const ky = ry * ELLIPSE_KAPPA;
    return [
      { xMm: rx, yMm: 0, handleIn: { xMm: rx - kx, yMm: 0 }, handleOut: { xMm: rx + kx, yMm: 0 } },
      { xMm: w, yMm: ry, handleIn: { xMm: w, yMm: ry - ky }, handleOut: { xMm: w, yMm: ry + ky } },
      { xMm: rx, yMm: h, handleIn: { xMm: rx + kx, yMm: h }, handleOut: { xMm: rx - kx, yMm: h } },
      { xMm: 0, yMm: ry, handleIn: { xMm: 0, yMm: ry + ky }, handleOut: { xMm: 0, yMm: ry - ky } },
    ];
  }
  return [
    { xMm: 0, yMm: 0 },
    { xMm: w, yMm: 0 },
    { xMm: w, yMm: h },
    { xMm: 0, yMm: h },
  ];
};
